// extracted by mini-css-extract-plugin
export var container = "_5h-1";
export var cornerButtonContainer = "_5h-6";
export var disabled = "_5h-2";
export var dragActive = "_5h-3";
export var fileContainer = "_5h-5";
export var hiddenInput = "_5h-4";
export var widthContainer = "_5h-0";